import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";

/** Renders children when authenticated; otherwise prompts sign-in. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, login } = useAuth();
  if (!isAuthenticated) {
    return (
      <div className="card">
        <h2>Sign in required</h2>
        <p className="muted">Please sign in to continue.</p>
        <div className="row">
          <button onClick={() => login()}>Sign in</button>
          <button className="secondary" onClick={() => login("Google")}>
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
